import React from 'react'
import { Checkbox, Tooltip, Fa, TextHeader } from '@eltoro-ui/components'
import { useReportHub } from '../../../Contexts/useReportHub'
import { ReportHubTimeframeSelector } from '../ReportHubTimeframeSelector'

export const ReportHubDashboardHeader: React.FC = () => {
  const { filters, handleFilterChange, isLoading } = useReportHub()

  return (
    <header
      className="ReportHubDashboardHeader mb-6"
      role="banner"
      aria-label="Dashboard header with filters and controls"
    >
      <TextHeader type={1}>Overview Dashboard</TextHeader>
      <div className="flex flex-wrap items-end justify-end gap-4">
        <div className="bg-base border-tint-gray-300 w-full rounded-lg border p-3 sm:w-auto sm:p-4">
          <Checkbox
            id="include-child-organizations"
            disabled={isLoading}
            label="Include Child Organizations"
            checked={filters.includeChildOrganizations}
            onChange={(checked) =>
              handleFilterChange({ includeChildOrganizations: checked })
            }
            className="text-sm"
            aria-describedby="child-org-help"
          />
          <div id="child-org-help" className="sr-only">
            Toggle to include data from child organizations in the dashboard
            metrics
          </div>
        </div>
        <div className="bg-base border-tint-gray-300 w-full rounded-lg border p-3 sm:w-auto sm:p-4">
          <div className="flex items-center gap-2">
            <Checkbox
              id="include-all-order-lines"
              disabled={isLoading}
              label={
                <>
                  Include All Order Lines
                  <Tooltip
                    content="Select this to include order lines in completed, paused, archived, rejected, approved statuses"
                    position="top"
                    size="s"
                  >
                    <Fa
                      icon="question-circle"
                      className="text-tint-gray-500 hover:text-tint-gray-700 cursor-help"
                      size={0.95}
                      type="light"
                    />
                  </Tooltip>
                </>
              }
              checked={filters.includeAllOrderLines}
              onChange={(checked) =>
                handleFilterChange({ includeAllOrderLines: checked })
              }
              className="text-sm"
              aria-describedby="order-lines-help"
            />
          </div>
          <div id="order-lines-help" className="sr-only">
            Toggle to include all order lines in the dashboard data
          </div>
        </div>
        {/* Timeframe Selector - only show when there's data */}
        <div className="w-full sm:w-auto">
          <ReportHubTimeframeSelector />
        </div>
      </div>
    </header>
  )
}
